import { STATIC_DISPLAY_MAP as u, ORDER as i } from "./constants.js";
import { isStaticKey as c } from "./guards.js";
function l(r) {
  return typeof KeyboardEvent < "u" && r instanceof KeyboardEvent;
}
const s = {
  Shift: "Shift",
  ShiftLeft: "Shift",
  ShiftRight: "Shift",
  Alt: "Alt",
  AltLeft: "Alt",
  AltRight: "Alt",
  Primary: "Primary",
  Control: "Primary",
  ControlLeft: "Primary",
  ControlRight: "Primary",
  Meta: "Primary",
  MetaLeft: "Primary",
  MetaRight: "Primary",
  OSLeft: "Primary",
  OSRight: "Primary",
  Plus: "Plus",
  NumpadAdd: "Plus",
  NumpadSubtract: "Minus",
  NumpadEnter: "Enter",
  NumpadDecimal: "Period"
};
function d(r) {
  const e = String(r), t = s[e];
  return t || (/^Numpad[0-9]$/.test(e) ? `Digit${e.slice(6)}` : e);
}
function a(r) {
  const e = l(r) ? d(r.code) : d(r), t = String(e);
  if (c(t)) {
    const o = u[t];
    return { id: e, label: o.label, order: o.order };
  }
  return /^Key[A-Z]$/.test(t) ? { id: e, label: t.slice(3), order: i.alpha } : /^Digit[0-9]$/.test(t) ? { id: e, label: t.slice(5), order: i.digit } : /^Numpad[0-9]$/.test(t) ? { id: e, label: t.slice(6), order: i.digit } : /^F(?:[1-9]|1[0-2])$/.test(t) ? { id: e, label: t, order: i.digit } : { id: e, label: t, order: i.fallback };
}
function m(r) {
  return l(r) || typeof r == "string" ? a(r) : r;
}
function y(r, e) {
  return r.order !== e.order ? r.order - e.order : r.id.localeCompare(e.id);
}
function g(r) {
  const e = r.map(m), t = /* @__PURE__ */ new Set();
  return e.filter((f) => {
    const n = String(f.id);
    return t.has(n) ? !1 : (t.add(n), !0);
  }).toSorted(y);
}
export {
  y as compareKeys,
  a as createKey,
  g as createKeyCombo
};
